import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ObjectBrowserSelectionTexts } from '@mirage-projects/cw-models';

import { ObjectBrowserSelectionService } from '../selection.service';

/**
 * Footer component to show in the objectbrowser
 * This footer enables to delete selection, clear it, and show only selected cards
 */
@Component({
    selector: 'cw-object-browser-selection',
    templateUrl: 'selection.component.html',
    styleUrls: ['selection.component.scss'],
    standalone: false,
})
export class ObjectBrowserSelectionComponent {
    /** Sets the show selected elements toggle */
    @Input() showSelectedElements = false;

    /** Resources for the options. When no resource in an option, it will hide it */
    @Input() selectionResources: ObjectBrowserSelectionTexts = {};

    /** Event that fires when show selected elements is toggled */
    @Output() showSelectedElementsChange = new EventEmitter<boolean>();
    /** Event that fires when the clear selection button is clicked */
    @Output() clearSelection = new EventEmitter<boolean>();
    /** Event that fires when the delete button is clicked */
    @Output() delete = new EventEmitter<void>();
    /** Event that fires when the create project button is clicked */
    @Output() createProject = new EventEmitter<void>();

    constructor(public selectionService: ObjectBrowserSelectionService) {}

    onShowElementsChanged(): void {
        this.showSelectedElements = !this.showSelectedElements;
        this.showSelectedElementsChange.emit(this.showSelectedElements);
    }

    onClearSelection(): void {
        this.showSelectedElements = false;
        this.clearSelection.emit();
    }

    onDelete(): void {
        this.delete.emit();
    }

    onCreateProject(): void {
        this.createProject.emit();
    }

    /**
     * Sets the number of elements selected resource, depending if only one selected or more
     */
    showSelectedText(): string {
        const selectedText =
            this.selectionService.getNumberSelectedElements() > 1
                ? this.selectionResources.showSelectedsText
                : this.selectionResources.showSelectedText;

        return selectedText ?? '';
    }
}
